import React, { PureComponent } from "react";
import Constants from "../Constants.js";

class MenuOuterTile extends PureComponent {
  render() {
    return (
      <div style={{
        width: Constants.menuTileSize + 'px',
        height: Constants.menuTileSize + 'px',
        position: 'absolute',
        backgroundColor: this.props.innerColor,
        left: (this.props.col * Constants.menuTileSize) + 'px',
        top: (this.props.row * Constants.menuTileSize) + 'px',
      }}>
        <div
          style={{
            backgroundColor: this.props.outerColor,
            height: '100%',
            width: '100%',
            borderTopLeftRadius: (this.props.topLeftRounded ? Constants.menuOuterBorderRadius : 0 ) + 'px',
            borderTopRightRadius: (this.props.topRightRounded ? Constants.menuOuterBorderRadius : 0 ) + 'px',
            borderBottomRightRadius: (this.props.bottomRightRounded ? Constants.menuOuterBorderRadius : 0 ) + 'px',
            borderBottomLeftRadius: (this.props.bottomLeftRounded ? Constants.menuOuterBorderRadius : 0 ) + 'px',
          }}
        />
      </div>
    );
  }
}

export default MenuOuterTile;
